import React from "react";
import { ColorIconProps, getColorIconSize } from "./utils";

const AllCorpusIcon: React.FC<ColorIconProps> = ({
  size = "default",
  className,
}) => {
  return (
    <svg
      width={getColorIconSize(size)}
      height={getColorIconSize(size)}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M14.7708 7.62512L14.7708 18.7085L10.4167 15.7001L6.06251 18.7085L6.06251 7.62512H14.7708Z"
        fill="var(--cdl-accent-fg-base)"
      />
      <path
        d="M14.771 6.79179C14.992 6.79183 15.204 6.87968 15.3602 7.03593C15.5164 7.1922 15.6043 7.40414 15.6043 7.62512V18.7083C15.6043 19.0181 15.4319 19.3025 15.1576 19.4464C14.9175 19.5722 14.6337 19.5728 14.3958 19.4529L14.2974 19.3943L10.4163 16.7128L6.53614 19.3943C6.28127 19.5703 5.94943 19.5903 5.67514 19.4464C5.4009 19.3025 5.22917 19.018 5.22917 18.7083V7.62512L5.23324 7.53967C5.27602 7.11956 5.63111 6.79179 6.06251 6.79179H14.771ZM6.89584 17.1197L9.94271 15.0144L10.0542 14.9502C10.3211 14.821 10.6406 14.8423 10.89 15.0144L13.9377 17.1197V8.45845H6.89584V17.1197Z"
        fill="var(--cdl-accent-fg-base)"
      />
      <path
        d="M1.66675 18.7503V8.06262C1.66675 7.60238 2.03985 7.22928 2.50009 7.22928C2.96032 7.22928 3.33342 7.60238 3.33342 8.06262V18.7503C3.33333 19.2104 2.96027 19.5836 2.50009 19.5836C2.0399 19.5836 1.66684 19.2104 1.66675 18.7503Z"
        fill="currentColor"
      />
      <path
        d="M10.4167 2.12512L18.3333 7.66679L10.4167 13.2085L2.50001 7.66679L10.4167 2.12512Z"
        fill="var(--cdl-bg-faint)"
      />
      <path
        d="M10.0505 1.37642C10.3196 1.24466 10.6433 1.26671 10.8944 1.44234L18.811 6.98433C19.0338 7.14027 19.1667 7.39518 19.1667 7.66711C19.1666 7.93889 19.0337 8.1932 18.811 8.34908L10.8944 13.8911C10.6075 14.0918 10.2259 14.0918 9.93897 13.8911L2.0223 8.34908C1.79966 8.1932 1.66678 7.93889 1.66667 7.66711C1.66667 7.39518 1.79953 7.14027 2.0223 6.98433L9.93897 1.44234L10.0505 1.37642ZM3.95183 7.6663L10.4167 12.191L16.8807 7.6663L10.4167 3.14156L3.95183 7.6663Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default AllCorpusIcon;
